import { useEffect, useState } from "react";
import { fetchContextInsights } from "../services/contextInsightsService";

export default function useContextInsights(defaultDays = 30, topK = 10) {
	const [range] = useState(() => {
		const end = new Date();
		const start = new Date(end.getTime() - defaultDays * 24 * 60 * 60 * 1000);
		return { start: start.toISOString(), end: end.toISOString() };
	});
	const [data, setData] = useState({ insights: [] });
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		let cancelled = false;
		(async () => {
			setLoading(true);
			setError(null);
			try {
				const res = await fetchContextInsights({ start: range.start, end: range.end, top_k: topK });
				if (!cancelled) setData(res);
			} catch (e) {
				if (!cancelled) setError(e?.response?.data?.message || e.message || "Failed to load insights");
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();
		return () => { cancelled = true; };
	}, [range, topK]);

	return { data, loading, error };
}


